import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import YunSheyuan from './components/YunSheyuan';
import YunDian from './components/YunDian';

export default function YunNode() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="九畴云铺数字商业节点 | 云社员与云店业务闭环"
        description="九畴云铺云社员与云店业务闭环，云社员可寻货卖货服务，云店将实体经营转化为数字经营，形成买货卖货服务的完整节点能力。"
        keywords="九畴云铺,云社员,云店,数字商业节点,买货卖货服务"
        path="/jiuchou/yun-node"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九畴云铺数字商业节点',
          description: '云社员与云店业务闭环',
        }}
      />
      <main>
        <Hero />
        <YunSheyuan />
        <TechImagePanel
          eyebrow="数字商业节点"
          title="每一个人，都是县域数字商业节点"
          desc="云社员与云店，把「买货 + 卖货 + 服务」变成每个人都能参与的县域数字商业节点能力。"
          chips={['云社员', '云店', '买货', '卖货', '服务']}
          stats={[
            { value: '3 入口', label: '寻货·卖货·服务' },
            { value: '1 身份', label: '数字节点' },
            { value: 'N 节点', label: '县域网络' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20constellation%20of%20individual%20human%20and%20storefront%20digital%20nodes%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20links%20connecting%20people%20into%20a%20commerce%20mesh%20network%2C%20rural%20digital%20economy%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-node&orientation=landscape"
          imageAlt="九畴云铺 数字商业节点"
        />
        <YunDian />
      </main>
      <Footer />
    </div>
  );
}